import { render, staticRenderFns } from "./EditPublicationForm.vue?vue&type=template&id=ed7a6edc&"
import script from "./EditPublicationForm.vue?vue&type=script&lang=js&"
export * from "./EditPublicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports